import { PROFESSIONAL_USER_ROLE } from '../../utils/constants';

export const handleLogoNavigation = connection => {
  return connection === PROFESSIONAL_USER_ROLE ? '/welcome' : '/';
};
